<template>
  <Modal
    :modal="modal"
    :titleIcons="[]"
    title="Informe o E-mail"
    @close="$emit('close')"
    @save="save"
    :loading="loading"
  >
    <v-form v-model="valid" ref="form">
      <v-autocomplete
        v-model="clienteEmail.tipo_email"
        :items="tiposEmail"
        item-text="descricao"
        label="Tipo"
        no-data-text="Nenhum registro encontrado"
      ></v-autocomplete>
      <v-text-field
        v-model="clienteEmail.email"
        label="Email"
        :autofocus="modal"
        :rules="[rules.required]"
      ></v-text-field>
    </v-form>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/shared/Modal';
import ClienteEmail from '@/domain/ClienteEmail';

export default {
  name: 'ModalClienteEmail',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    editClienteEmail: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal
  },
  data: () => ({
    loading: false,
    valid: true,
    clienteEmail: new ClienteEmail(),
    rules: {
      required: v => !!v || 'Campo obrigatório'
    }
  }),
  watch: {
    modal(value) {
      if (!value) this.clienteEmail = new ClienteEmail();
    },
    editClienteEmail(value) {
      if (value) this.clienteEmail = value;
    }
  },

  computed: {
    ...mapGetters(['tiposEmail'])
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        if (!this.editClienteEmail) {
          this.$emit('save', this.clienteEmail);
        } else {
          this.$emit('update', this.clienteEmail);
        }
      }
    }
  }
}
</script>

<style>

</style>